import { TestIframe } from '../TestIframe/TestIframe';
import { CertificateCard } from 'components/CertificateCard/CertificateCard';
import { LoadingPlaceholder } from '@trackman/web-shared-components';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useGetLearningHubTestContent } from 'queryHooks/learningHub';

type CertificationExamProps = {
  title: string;
  isCompleted: boolean;
  certificationId: string;
  moduleId: string;
  progress: number;
  badgeImageUrl: string;
};

export const CertificationExam = ({ title, isCompleted, certificationId, moduleId, progress, badgeImageUrl }: CertificationExamProps) => {
  const queryClient = useQueryClient();
  const testContent = useGetLearningHubTestContent(certificationId);

  useEffect(
    () => () => {
      if (!isCompleted) {
        queryClient.invalidateQueries({ queryKey: ['moduleContents', moduleId] });
      }
    },
    []
  );

  return (
    <>
      {!testContent.isPending ? (
        !isCompleted ? (
          <TestIframe area9LaunchUrl={testContent.data.launchUrl} lessonParams={testContent.data.parameters} />
        ) : (
          <CertificateCard
            id={certificationId}
            title={title}
            status='Completed'
            description=''
            prerequisites={[]}
            progress={progress}
            badgeImageUrl={badgeImageUrl}
          />
        )
      ) : (
        <LoadingPlaceholder />
      )}
    </>
  );
};
